<template>
  <div class="moow-master-container" id="view-content">
    <!-- <nav-master></nav-master> -->
    <md-progress-bar
      md-mode="indeterminate"
      class="absolute-progress"
      v-if="listingLoadProgress!=100"
    ></md-progress-bar>
    <b-container class="dashboard-container">
      <b-row>
        <md-button
          class="md-fab md-primary play-cta-button makeup show-on-small fixed"
          @click="startNewListing"
        >
          <md-icon>add</md-icon>
        </md-button>
        <b-col xl="1" lg="1" md="0" />
        <b-col xl="10" lg="10" md="12" class="m-0 p-0">
          <div @click="reloadDashListings" class="help-action-btn reload-items">
            <md-button class="md-icon-button md-raised" :disabled="listingLoadProgress!=100">
              <div
                v-if="listingLoadProgress!=100"
                class="loader-rolling-local_white"
                style="color:white"
              ></div>
              <md-icon v-else>cached</md-icon>
            </md-button>
          </div>
          <div @click="showHelpDialog('propStatus')" class="help-action-btn help-dialog">
            <md-button class="md-fab md-dense play-cta-fab_flat">
              <md-icon>help_outline</md-icon>
            </md-button>
          </div>
          <md-tabs
            md-swipeable
            md-dynamic-height
            :md-active-tab="activeTab"
            id="mo-accent"
            @md-changed="changedTab"
            class="md-primary play-tabs dark"
            md-elevation="5"
          >
          
            <md-tab
              id="tab-active"
              :md-label="i18n_local.propert_state_live"
              class="mo-listings-tab play-tab"
            >
              <dashboard-listings
                :progress="activeListingMetaData[0].listingProgress"
                :dashListings="activeDashListings"
                :filteredProperties="filteredActiveProperties"
                :createNewListing="startNewListing"
                :editListing="editPage"
                :manageListing="managePage"
                :previewListing="previewPage"
                :openListings="true"
                @refresListings="refreshDashListings"
                @filteringRequested="onActivePropertiesFilteringRequested"
                @resetFilteringRequested="onResetActivePropertiesFilteringRequested"
                tabCategory="active"
              ></dashboard-listings>
              <div class="md-layout md-alignment-bottom-center mt-3">
                <div v-if="propertiesRequestPending" class="loader-rolling-local_blue"></div>
              </div>
            </md-tab>

            <md-tab
              id="tab-draft"
              md-dynamic-height
              :md-label="i18n_local.propert_state_stored"
              class="mo-listings-tab"
            >
              <dashboard-listings
                :progress="draftListingMetaData[0].listingProgress"
                :dashListings="draftDashListings"
                :filteredProperties="filteredDraftProperties"
                :createNewListing="startNewListing"
                :editListing="editPage"
                :manageListing="managePage"
                :previewListing="previewPage"
                :openListings="true"
                @refresListings="refreshDashListings"
                @filteringRequested="onDraftPropertiesFilteringRequested"
                @resetFilteringRequested="onResetDraftPropertiesFilteringRequested"
                tabCategory="draft"
              ></dashboard-listings>
              <div class="md-layout md-alignment-bottom-center mt-3">
                <div v-if="propertiesRequestPending" class="loader-rolling-local_blue"></div>
              </div>
            </md-tab>

            <md-tab
              id="tab-archived"
              md-dynamic-height
              :md-label="i18n_local.propert_state_archived"
              class="mo-listings-tab"
            >
              <dashboard-listings
                :progress="archivedListingMetaData[0].listingProgress"
                :dashListings="archivedDashListings"
                :createNewListing="startNewListing"
                :editListing="editPage"
                :previewListing="previewPage"
                :openListings="false"
                @refresListings="refreshDashListings"
                tabCategory="archived"
              ></dashboard-listings>
              <div class="md-layout md-alignment-bottom-center mt-3">
                <div v-if="propertiesRequestPending" class="loader-rolling-local_blue"></div>
              </div>
            </md-tab>
          </md-tabs>
        </b-col>
        <b-col xl="1" lg="1" md="0" />
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { getProperties } from "../listingFunctions";
import { getListingCoverThumbnail } from "../listingsRepository.js";
import DashboardListings from "../components/dashboardListings.vue";
import DashboardDrawer from "../components/dashboard/dashDrawer.vue";
import { mapGetters } from "vuex";
import  {showTutorial, hideTutorial} from '@/platform/utils/tutorial/index.js'
var lodash = require("lodash/function");

export default {
  props: {
    preState: {
      type: Object,
      required: false
    },
    openWithTab: {
      type: String,
      required: false,
    },
  },
  components: {
    "dashboard-listings": DashboardListings,
    "dashboard-drawer": DashboardDrawer
  },
  data() {
    return {
      nihu: 1,
      activeName: "open",
      openDashListings: [],
      // activeDashListings: [],
      // draftDashListings: [],
      // archivedDashListings: [],
      closed: false,
      openPressed: true,
      closePressed: false,
      closeVisitedFirstTime: true,
      noActiveListings: false,
      noDraftListings: false,
      noArchivedListings: false,
      reloadingsListings: false,
      activeTab: "tab-active",
      defaultTab: "tab-active",
      reloadArchivedListingsOnTabVisit: true,
      preLoadingActive: false,
      preLoadingDraft: false,
      preLoadingArchived: false,
      listings: [],
      draftListingMetaData: [{ listingProgress: 100 }], //using array due to its reactivity
      activeListingMetaData: [{ listingProgress: 100 }], //using array due to its reactivity
      archivedListingMetaData: [{ listingProgress: 100 }], //using array due to its reactivity
      listingLoadErrors: [],
      lastScrollTop: 0,
      showDashboardTutorial: false
    };
  },
  watch: {
    showDashboardTutorial: function (val) {
      if(val){
        showTutorial("global-dash-edit-listing", document, "To publish your listing click on LISTING and go to AVAILABILITY tab", this.notifyUser)
      } 
    },
    draftDashListings: function(val){
      if(val.length > 0) this.showTutorialsIfNecessary()
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    filteredActiveProperties() {
        return this.$store.getters.filteredActiveProperties;
    },
    filteredDraftProperties() {
        return this.$store.getters.filteredDraftProperties;
    },
    activeDashListings() {
        if (this.filteredActiveProperties.length) {
            return this.filteredActiveProperties;
        }
        return this.$store.getters.activeProperties;
    },
    draftDashListings() {
      if (this.filteredDraftProperties.length) return this.filteredDraftProperties;
      return this.$store.getters.draftProperties;
    },
    archivedDashListings() {
      return this.$store.getters.archivedProperties;
    },
    canLoadMoreActiveProperties() {
      return this.$store.getters.canLoadMoreActiveProperties;
    },
    canLoadMoreDraftProperties() {
      return this.$store.getters.canLoadMoreDraftProperties;
    },
    canLoadMoreArchivedProperties() {
      return this.$store.getters.canLoadMoreArchivedProperties;
    },
    activePropertiesPageNumber() {
      return this.$store.getters.activePropertiesPageNumber;
    },
    draftPropertiesPageNumber() {
      return this.$store.getters.draftPropertiesPageNumber;
    },
    archivedPropertiesPageNumber() {
      return this.$store.getters.archivedPropertiesPageNumber;
    },
    pageLimit() {
      return this.$store.getters.pageLimit;
    },
    propertiesRequestPending() {
      return this.$store.getters.propertiesRequestPending;
    },
    listingLoadProgress() {
      if (this.activeTab == "tab-active")
        return this.activeListingMetaData[0].listingProgress;
      if (this.activeTab == "tab-draft")
        return this.draftListingMetaData[0].listingProgress;
      if (this.activeTab == "tab-archived")
        return this.archivedListingMetaData[0].listingProgress;
      else return 100;
    },
    emptyListingPlaceholder() {
      return require("../assets/add_listing.svg");
    },
    placeholder() {
      return require("../assets/placeholder.png");
    },
    refreshIcon() {
      return require("../assets/refresh.svg");
    },
    loaderRolling() {
      return required("../assets/loader-rolling.svg");
    },
    customSort(a, b) {
      return b.creationDet.lstModDate - a.creationDet.lstModDate;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if(this.preState) this.restorePreState(this.preState)
  },
  created() {
    this.$emit("emitChangeViewTitle", "Your Properties");
    var memTabId = sessionStorage.getItem("lastVisitedDashboardTabId");
    if(this.openWithTab) memTabId = this.openWithTab
    else if (!memTabId) memTabId = this.defaultTab;
    this.changedTab(memTabId);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  updated() {},
  methods: {
    showTutorialsIfNecessary(){
      let hasSeenDashboardTutorial = localStorage.getItem("has_seen_dashboard_tutorial")
      console.log('showTutorialsIfNecessary | hasSeenDashboardTutorial:', hasSeenDashboardTutorial);
      if(!hasSeenDashboardTutorial) {
        localStorage.setItem("has_seen_dashboard_tutorial", true)
        this.showDashboardTutorial = true
      }
    },
    restorePreState(preState){
      if(preState.yScroll){
        setTimeout(function () {
          window.scrollTo(0, preState.yScroll);
        }, 500);
      } 
      if(preState.tab) this.changedTab(preState.tab)
    },
    handleScroll: lodash.debounce(function(event) {
      var st = window.pageYOffset || document.documentElement.scrollTop; 
      if (st > this.lastScrollTop) {
        // downscroll code
        this.attemptLoadMoreProperties();
      } else {
        // upscroll code
      }
      // lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      // if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      //   this.attemptLoadMoreProperties();
      // }
    }, 300),
    attemptLoadMoreProperties() {
      if(!this.canLoadMoreActiveProperties && !this.canLoadMoreDraftProperties && !this.canLoadMoreArchivedProperties) return;
      var loadFunction, canLoadMore, propStatus, metaData, pageNumber;
      switch (this.activeTab) {
        case "tab-active":
          canLoadMore = this.canLoadMoreActiveProperties;
          propStatus = "active";
          metaData = this.activeListingMetaData;
          pageNumber = this.activePropertiesPageNumber;
          break;
        case "tab-draft":
          canLoadMore = this.canLoadMoreDraftProperties;
          propStatus = "draft";
          metaData = this.draftListingMetaData;
          pageNumber = this.draftPropertiesPageNumber;
          break;
        case "tab-archived":
          canLoadMore = this.canLoadMoreArchivedProperties;
          propStatus = "archived";
          metaData = this.archivedListingMetaData;
          pageNumber = this.archivedPropertiesPageNumber;
          break;
        default:
          break;
      }
      if (!this.propertiesRequestPending && canLoadMore)
        this.loadMoreProperties(propStatus, metaData, pageNumber, canLoadMore);
    },
    showHelpDialog(whatAbout) {
      var title = "";
      var message = "";
      if (whatAbout == "propStatus") {
        title = this.i18n_local.info.property_status;
        message = this.i18n_local.info.property_statuses
      }
      this.$emit("emitToggleHelpDialog", { title, message });
    },
    setPropertiesInView() {
      if (this.propertiesRequestPending) {
        return;
      }
      if (this.activeTab == "tab-draft" && !this.draftDashListings.length) {
        this.$store.commit("CLEAR_DRAFT_PROPERTIES");
        getProperties(
          "draft",
          this.listingLoadErrors,
          this.draftListingMetaData,
          0,
          this.pageLimit
        );
      } else if (
        this.activeTab == "tab-active" &&
        !this.activeDashListings.length
      ) {
        this.$store.commit("CLEAR_ACTIVE_PROPERTIES");
        getProperties(
          "active",
          this.listingLoadErrors,
          this.activeListingMetaData,
          0,
          this.pageLimit
        );
      } else if (
        this.activeTab == "tab-archived" &&
        !this.archivedDashListings.length
      ) {
        this.$store.commit("CLEAR_ARCHIVED_PROPERTIES");
        getProperties(
          "archived",
          this.listingLoadErrors,
          this.archivedListingMetaData,
          0,
          this.pageLimit
        );
      }
    },
    reloadDashListings() {
      // removes from local storage so that setPropertiesInView() will have to download from server
      if (this.activeTab == "tab-active")
        this.$store.commit("CLEAR_ACTIVE_PROPERTIES");
      if (this.activeTab == "tab-draft")
        this.$store.commit("CLEAR_DRAFT_PROPERTIES");
      if (this.activeTab == "tab-archived")
        this.$store.commit("CLEAR_ARCHIVED_PROPERTIES");
      this.setPropertiesInView();
    },
    refreshDashListings() {
      // this.setPropertiesInView();
    },
    changedTab(tabId) {
      this.activeTab = tabId;
      sessionStorage.setItem("lastVisitedDashboardTabId", tabId);
      this.setPropertiesInView();
    },
    getListingCoverThumbnail(listing) {
      return getListingCoverThumbnail(listing);
    },
    orderListings(listings) {
      function compare(a, b) {
        const listingA = a.creationDet.lstModDate;
        const listingB = b.creationDet.lstModDate;

        let comparison = 0;
        if (listingA < listingB) {
          comparison = 1;
        } else if (listingA > listingB) {
          comparison = -1;
        }
        return comparison;
      }

      return listings.sort(compare);
    },
    editPage(property) {
      var id = property.maaklerID;
      this.$emit("emitGoForward", {where: 'editListing', params: {listingId: id}})

      // this.$router.push({
      //   name: "editListing",
      //   params: {
      //     listingId: id
      //   }
      // });
    },
    previewPage(id) {

      let routeData = this.$router.resolve({
        name: "listing",
        params: {
          listingId: id
        }
      });
      window.open(routeData.href, "_blank");
     
    },
    managePage(data) {
      this.$emit("emitGoForward", {where: 'manage', params: {listing: data}, preState: {tab: this.activeTab, yScroll: window.scrollY}})
    },
    startNewListing() {
      this.$store.commit("RESET_LISTING");
      this.$store.commit("RESET_LISTING_ADD_PROGRESS");
      this.$store.commit("RESET_VISITED_PAGES");
      sessionStorage.removeItem("buildingServiceData");
      sessionStorage.removeItem("locationServiceLoc");
      sessionStorage.setItem("newListing", true);
      sessionStorage.setItem("basicStatus", 0);
      sessionStorage.setItem("uploadedSomeImages", false);

      this.$router.push({
        name: "addListing1"
      });
    },
    closeListing() {
      this.displayArchivedListings();
      this.closed = true;
      this.closePressed = true;
      this.openPressed = false;
    },
    openListing() {
      this.displayOpenListings();
      this.closed = false;
      this.closePressed = false;
      this.openPressed = true;
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    loadMoreProperties(propStatus, metaData, pageNumber, canLoadMore) {
      if (!canLoadMore) {
        return;
      }
      getProperties(
        propStatus,
        this.listingLoadErrors,
        metaData,
        pageNumber,
        this.pageLimit
      );
    },
    onActivePropertiesFilteringRequested(searchString) {
        if (!searchString || searchString.length < 3) {
            return;
        }
        this.$store.dispatch('filterActiveProperties', searchString);
    },
    onDraftPropertiesFilteringRequested(searchString) {
        if (!searchString || searchString.length < 3) {
            return;
        }
        this.$store.dispatch('filterDraftProperties', searchString);
    },
    onResetActivePropertiesFilteringRequested() {
        this.$store.dispatch('resetFilteredActiveProperties');
    },
    onResetDraftPropertiesFilteringRequested() {
        this.$store.dispatch('resetFilteredDraftProperties');
    },
  }
};
</script>
<style scoped>
@import "../assets/styles/listings-view.css";
@import "../assets/styles/dashboard.css";
@import "../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/Listing.vue